import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import {
  updateIndividualTransitionToForVerification as updateIndividualTransitionToForVerificationCall,
} from '../../lib/store/crm';
import {
  isAuthEnrollPortalStatusInitial,
  isAuthEnrollPortalStatusPending,
} from '../../lib/store/selectors';

import experienceAllCompletedImage from '../../assets/bigImages/experience_all_completed.png';
import { useIsMobile } from '../../hooks';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import { UI_ROUTES } from '../../util/routes';

import styles from './EnrollAccountActivated.module.scss';

type Props = {}

const EnrollAccountActivated = (props: Props) => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isEnrollPortalStatusInitial:boolean = useSelector((state: RootState) => isAuthEnrollPortalStatusInitial(state));
  const isEnrollPortalStatusPending:boolean = useSelector((state: RootState) => isAuthEnrollPortalStatusPending(state));

  if (!isEnrollPortalStatusInitial && !isEnrollPortalStatusPending) {
    navigate(-1);
  }

  return (
    <>
      <div className={[styles.textsWrapper, isMobile ? styles.textsWrapperMob : undefined].join(' ')}>
        <div className={styles.imageWrapper}>
          <img
            src={experienceAllCompletedImage}
            className={styles.image}
            alt=""
          />
        </div>
        <p className={styles.caption}>
          {lang.commonOnboardingExperienceTradingProfileComplete()}
        </p>
        <p className={styles.description}>
          {lang.commonOnboardingExperienceItMayTakeADay()}
        </p>
        <p className={styles.line} />
        <Button
          id="closeEnrollment"
          ariaLabel="close enrollment"
          variant={ButtonTypesEnum.Primary}
          onClick={() => {
            dispatch(updateIndividualTransitionToForVerificationCall());
            navigate(UI_ROUTES.overview);
          }}
          className={classNames(styles.submitButton, { [styles.skipButton]: true })}
        >
          {lang.commonContinueButton()}
        </Button>
      </div>
    </>
  );
};

export default EnrollAccountActivated;
